import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconHelp, IconPharmacy, IconSupport } from '@redteclab/icons'

import { useGlobalConfigContext } from '../../../global-config'
import {
  urlResolverGetFaq,
  urlResolverGetHelpCentrePharmaPage,
  urlResolverGetOtherTopicsContactPage,
} from '../../../url-handling'
import {
  CONTACT_FALLBACK_CTA_TYPE,
  CONTACT_PAGE_FS_SCHEMA_CTAS,
  PHARMA_CTA_TYPE,
} from '../../gtm/model'

import { ContactPageAccountCta } from './ContactPageAccountCta'
import { ContactPageSectionFlatCta } from './ContactPageSectionFlatCta'

export const ContactPageCommonCtas: FC<{
  isUserLoggedIn: boolean
}> = ({ isUserLoggedIn }) => {
  const globalConfig = useGlobalConfigContext()

  return (
    <>
      <ContactPageAccountCta isUserLoggedIn={isUserLoggedIn} />

      <ContactPageSectionFlatCta<'a'>
        className="order-3 tablet:order-2"
        data-qa-id="qa-id-help-center-faq-cta"
        href={urlResolverGetFaq(globalConfig)}
        startIcon={<IconHelp className="text-dark-primary-max" />}
      >
        <FormattedMessage id="header.link.label.help" />
      </ContactPageSectionFlatCta>

      <ContactPageSectionFlatCta<'a'>
        className="order-2 tablet:order-3"
        data-fs-properties-schema={CONTACT_PAGE_FS_SCHEMA_CTAS}
        data-qa-id="qa-id-help-center-pharma-page"
        data-type={PHARMA_CTA_TYPE}
        href={urlResolverGetHelpCentrePharmaPage(globalConfig)}
        startIcon={<IconPharmacy className="text-dark-primary-max" />}
      >
        <FormattedMessage id="contactForm.select.item.consultation" />
      </ContactPageSectionFlatCta>

      <ContactPageSectionFlatCta<'a'>
        className="order-4 tablet:order-4"
        data-fs-properties-schema={CONTACT_PAGE_FS_SCHEMA_CTAS}
        data-qa-id="qa-id-help-center-other-topics-page"
        data-type={CONTACT_FALLBACK_CTA_TYPE}
        href={urlResolverGetOtherTopicsContactPage(globalConfig)}
        startIcon={<IconSupport className="text-dark-primary-max" />}
      >
        <FormattedMessage id="header.link.label.contact" />
      </ContactPageSectionFlatCta>
    </>
  )
}
